var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeechDtc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00005 12.1667V15.5M6.00005 15.5H3.50005M6.00005 15.5H8.50005M10.7816 8.62853C10.4729 9.63828 9.85241 10.5244 9.00913 11.1598C8.16585 11.7953 7.14305 12.1475 6.08732 12.1659C5.03158 12.1843 3.99711 11.8681 3.13217 11.2624C2.26723 10.6568 1.61623 9.79288 1.27246 8.79451M6.00005 8.83333C5.07958 8.83333 4.33339 8.08714 4.33339 7.16667V2.16667C4.33339 1.24619 5.07958 0.5 6.00005 0.5C6.92053 0.5 7.66672 1.24619 7.66672 2.16667V7.16667C7.66672 8.08714 6.92053 8.83333 6.00005 8.83333Z",
    stroke: "#787878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechDtc);
export default __webpack_public_path__ + "static/media/speechDtc.527050f026f515cd38cc21d352d2b32a.svg";
export { ForwardRef as ReactComponent };